"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _axios = _interopRequireDefault(require("axios"));
var _vuex = require("vuex");
var _cn = _interopRequireDefault(require("@/lang/cn"));
var _en = _interopRequireDefault(require("@/lang/en"));
var _index = require("@/utils/index");
var _quarterDate = _interopRequireDefault(require("./components/quarterDate"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MONTH = 'month'; // 月度
var QUARTER = 'quarter'; // 季度
var _default = exports.default = {
  components: {
    QuarterDate: _quarterDate.default
  },
  data: function data() {
    var _this = this;
    var moduleKey = window.location.href.includes('monthKPI') ? MONTH : QUARTER;
    var checkStartQuarter = function checkStartQuarter(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('common.pleaseSelect')));
      } else if (_this.exportQuarterForm.endQuarter) {
        var _this$checkQuarter = _this.checkQuarter(value, _this.exportQuarterForm.endQuarter),
          _this$checkQuarter2 = (0, _slicedToArray2.default)(_this$checkQuarter, 2),
          isValid = _this$checkQuarter2[0],
          message = _this$checkQuarter2[1];
        if (!isValid) {
          return callback(new Error(message));
        }
      }
      callback();
    };
    var checkEndQuarter = function checkEndQuarter(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('common.pleaseSelect')));
      } else if (_this.exportQuarterForm.startQuarter) {
        var _this$checkQuarter3 = _this.checkQuarter(_this.exportQuarterForm.startQuarter, value),
          _this$checkQuarter4 = (0, _slicedToArray2.default)(_this$checkQuarter3, 2),
          isValid = _this$checkQuarter4[0],
          message = _this$checkQuarter4[1];
        if (!isValid) {
          return callback(new Error(message));
        }
      }
      callback();
    };
    return {
      pageName: moduleKey === MONTH ? 'monthKPI' : 'quarterKPI',
      moduleKey: moduleKey,
      sourceApi: null,
      listLoading: false,
      titleList: [],
      // 表头
      itemList: [],
      // 表格
      timeRange: [],
      // 导出 区间限制2年
      exportDialog: false,
      // 导出弹窗
      downloadLoading: false,
      exportForm: {
        rangeTime: []
      },
      exportFormRule: {
        rangeTime: [{
          required: true,
          message: this.$t('common.pleaseSelect'),
          trigger: 'change'
        }]
      },
      pickerOptions: {
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          if (minDate) {
            var currentMonth = minDate.getMonth();
            _this.pickerMinDate = new Date(minDate).setMonth(currentMonth - 23);
            _this.pickerMaxDate = new Date(minDate).setMonth(currentMonth + 23);
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this.pickerMinDate != null) {
            // 限制前后2年的时间
            return time.getTime() < _this.pickerMinDate || _this.pickerMaxDate < time.getTime();
          }
        }
      },
      exportQuarterForm: {
        startQuarter: '',
        endQuarter: ''
      },
      exportQuarterFormRule: {
        startQuarter: [{
          required: true,
          validator: checkStartQuarter,
          trigger: 'change'
        }],
        endQuarter: [{
          required: true,
          validator: checkEndQuarter,
          trigger: 'change'
        }]
      },
      startQuarterVisible: false,
      endQuarterVisible: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    this.fetchListData();
  },
  methods: {
    baseParams: function baseParams() {
      var roles = this.$store.getters.roles || []; // 当前角色
      var _ref2 = this.$store.state.user || {},
        userInfo = _ref2.userInfo;
      var empNo = userInfo.empNo || '';
      return {
        empNo: empNo,
        // 工号
        roleCode: roles[0] // 角色
      };
    },
    fetchListData: function fetchListData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = this.baseParams();
      this.listLoading = true;
      this.$api.reportModule.getKpiList(this.moduleKey, param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.handleData(res.data);
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    handleData: function handleData(resData) {
      var titleList = resData.titleList,
        itemList = resData.itemList;
      var tableLangCn = _cn.default.sfe.reportModule.table;
      var tableLangEn = _en.default.sfe.reportModule.table;
      if (Array.isArray(titleList) && titleList.length) {
        titleList.forEach(function (item) {
          // 加上翻译
          item.titleMonth_en = item.titleMonth.replace("".concat(tableLangCn.year), " ".concat(tableLangEn.year, " ")).replace(/[0-9]+月$/, function (item) {
            return (0, _index.monthTransToEn)(item);
          });
        });
        // 插入title
        var titleMonth = this.moduleKey === MONTH ? '' : '';
        var titleMonth_en = this.moduleKey === MONTH ? '' : '';
        titleList.unshift({
          titleMonth: titleMonth,
          titleMonth_en: titleMonth_en,
          column: 'name'
        });
      }
      if (Array.isArray(itemList) && itemList.length) {
        var arr = [{
          name: tableLangCn.tpp,
          name_en: tableLangEn.tpp
        }, {
          name: tableLangCn.targetSales,
          name_en: tableLangEn.targetSales
        }, {
          name: tableLangCn.acturlSales,
          name_en: tableLangEn.acturlSales
        }, {
          name: tableLangCn.targetSales18,
          name_en: tableLangEn.targetSales18
        }, {
          name: tableLangCn.acturlSales18,
          name_en: tableLangEn.acturlSales18
        }, {
          name: tableLangCn.targetStoreNum,
          name_en: tableLangEn.targetStoreNum
        }, {
          name: tableLangCn.acturlStoreNum,
          name_en: tableLangEn.acturlStoreNum
        }, {
          name: tableLangCn.targetActiveStoreNum,
          name_en: tableLangEn.targetActiveStoreNum
        }, {
          name: tableLangCn.acturlActiveStoreNum,
          name_en: tableLangEn.acturlActiveStoreNum
        }, {
          name: tableLangCn.activeStoreNum18,
          name_en: tableLangEn.activeStoreNum18
        }];
        // 翻译
        itemList.forEach(function (item) {
          var index = arr.findIndex(function (t) {
            return t.name === item.name;
          });
          if (index > -1) {
            item.name_en = arr[index].name_en;
            item.sort = index + 1;
          }
        });
        // 排序
        itemList.sort(function (t1, t2) {
          return t1.sort - t2.sort;
        });
      }
      this.titleList = titleList || [];
      // 分成三个
      this.itemList = [(0, _toConsumableArray2.default)(itemList.slice(0, 3)), (0, _toConsumableArray2.default)(itemList.slice(3, 5)), (0, _toConsumableArray2.default)(itemList.slice(5))];
    },
    closeExportPopup: function closeExportPopup() {
      if (this.startQuarterVisible) {
        this.startQuarterVisible = false;
      }
      if (this.endQuarterVisible) {
        this.endQuarterVisible = false;
      }
    },
    checkQuarter: function checkQuarter(start, end) {
      var startDate = start.split('-');
      var endDate = end.split('-');
      if (startDate[0] > endDate[0] || startDate[0] === endDate[0] && startDate[1] > endDate[1]) {
        return [false, this.$t('sfe.reportModule.quarterError1')];
      }
      if (startDate[0] < endDate[0]) {
        var space_quarters = 4 - parseInt(startDate[1]) + 1 + (endDate[0] - startDate[0] - 1) * 4 + parseInt(endDate[1]);
        if (space_quarters > 4 * 2) {
          return [false, this.$t('sfe.reportModule.quarterError2')];
        }
      }
      return [true];
    },
    openExportDialog: function openExportDialog() {
      var _this3 = this;
      this.exportDialog = true;
      this.$nextTick(function () {
        var dialog = document.querySelector('.report-export .el-dialog');
        if (dialog) {
          dialog.addEventListener('click', _this3.closeExportPopup);
        }
      });
    },
    closeExportDialog: function closeExportDialog() {
      if (this.moduleKey === MONTH) {
        this.$refs.exportForm.resetFields();
      } else {
        this.$refs.exportQuarterForm.resetFields();
      }
      var dialog = document.querySelector('.report-export .el-dialog');
      if (dialog) {
        dialog.removeEventListener('click', this.closeExportPopup);
      }
      this.closeExportPopup();
      this.exportDialog = false;
    },
    rangeTimeBlur: function rangeTimeBlur() {
      this.pickerMinDate = null;
      this.pickerMaxDate = null;
    },
    submitExportDialog: function submitExportDialog() {
      var _this4 = this;
      var form = this.moduleKey === MONTH ? 'exportForm' : 'exportQuarterForm';
      this.$refs[form].validate(function (valid) {
        if (valid) {
          _this4.downloadExcel();
        }
      });
    },
    downloadExcel: function downloadExcel(name) {
      var _this5 = this;
      var baseParams = this.baseParams();
      var param = (0, _objectSpread2.default)({}, baseParams);
      if (this.moduleKey === MONTH) {
        var rangeTime = this.exportForm.rangeTime;
        param.startMonth = rangeTime[0];
        param.endMonth = rangeTime[1];
      } else {
        var _this$exportQuarterFo = this.exportQuarterForm,
          startQuarter = _this$exportQuarterFo.startQuarter,
          endQuarter = _this$exportQuarterFo.endQuarter;
        param.startQuarter = startQuarter.split('-').join('');
        param.endQuarter = endQuarter.split('-').join('');
      }
      this.downloadLoading = true;
      this.$api.reportModule.exportKpiData(this.moduleKey, param, this.sourceApi.token).then(function (res) {
        _this5.downloadLoading = false;
        var fileName = '';
        if (_this5.moduleKey === MONTH) {
          fileName = "".concat(_this5.$t('route.monthkpi'), "(").concat(param.startMonth, "-").concat(param.endMonth, ").xlsx");
        } else {
          var start_text = param.startQuarter.substr(0, 4) + 'Q' + param.startQuarter.substr(4 + 1);
          var end_text = param.endQuarter.substr(0, 4) + 'Q' + param.endQuarter.substr(4 + 1);
          fileName = "".concat(_this5.$t('route.quarterkpi'), "(").concat(start_text, "-").concat(end_text, ").xlsx");
        }
        (0, _index.downloadFileExcel)(fileName, res.data, true);
        setTimeout(function () {
          _this5.closeExportDialog();
        }, 500);
      }).finally(function () {
        _this5.downloadLoading = false;
      });
    },
    update_startQuarter: function update_startQuarter(val) {
      this.exportQuarterForm.startQuarter = val;
      this.startQuarterVisible = false;
    },
    update_endQuarter: function update_endQuarter(val) {
      this.exportQuarterForm.endQuarter = val;
      this.endQuarterVisible = false;
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};